import styled from "styled-components";
import { fonts, media } from "../system";

export const PageTitle = styled.h1<{ center?: boolean }>`
  /* We use a lower top margin here to compensate for extra padding so when page auto scrolls
  to title there is sufficient spacing between top of viewport and title */
  ${props => props.center && "text-align: center;"}
  margin: -6px 0 10px;
  font-weight: 700;
  font-size: 30px;
  font-family: ${fonts.primary};
  line-height: 38px;
  padding-top: 14px;
  padding-bottom: 0;
  text-overflow: ellipsis;
  overflow: hidden;
  letter-spacing: -0.2px;

  ${media.tablet`
    margin: 2px 0 10px;
    padding-top: 0;
  `};

  ${media.desktop`
    margin: 10px 0 10px;
  `};
`;
